import type { AxiosInstance } from 'axios';
import { injectable } from 'inversify';
import { action, makeObservable, observable } from 'mobx';
import { Result } from 'services/Result';

export class FeatureConfigData {
  constructor() {
    makeObservable(this);
  }

  @observable isUploadVideoEnabled = false;
  @observable isRoboUmpEnabled = false;
  @observable isPlayerPositioningEnabled = false;
  @observable isPlayerTrackingEnabled = false;
  @observable isNetworkedSystem = false;
  @observable isPitchComIntegrationEnabled = false;
  @observable isBatTrackingEnabled = false;
  @observable isOperatorlessTaggingEnabled = false;
  @observable isDualSystemArmingEnabled = false;

  @action updateFrom(value: FeatureConfigData): void {
    this.isUploadVideoEnabled = value.isUploadVideoEnabled;
    this.isRoboUmpEnabled = value.isRoboUmpEnabled;
    this.isPlayerPositioningEnabled = value.isPlayerPositioningEnabled;
    this.isPlayerTrackingEnabled = value.isPlayerTrackingEnabled;
    this.isNetworkedSystem = value.isNetworkedSystem;
    this.isPitchComIntegrationEnabled = value.isPitchComIntegrationEnabled;
    this.isBatTrackingEnabled = value.isBatTrackingEnabled;
    this.isOperatorlessTaggingEnabled = value.isOperatorlessTaggingEnabled;
    this.isDualSystemArmingEnabled = value.isDualSystemArmingEnabled;
  }
}

export interface IFeatureConfigService {
  getConfig(): FeatureConfigData;
  fetchConfig(): Promise<boolean>;
}

@injectable()
export class FeatureConfigService implements IFeatureConfigService {
  private static featureConfig: FeatureConfigData = new FeatureConfigData();

  private axiosInstance: AxiosInstance;

  constructor(axiosInstance: AxiosInstance) {
    this.axiosInstance = axiosInstance;
  }

  public getConfig(): FeatureConfigData {
    return FeatureConfigService.featureConfig;
  }

  async fetchConfig(): Promise<boolean> {
    const response = await this.axiosInstance.get<Result<FeatureConfigData>>('api/feature/config');
    if (response.data && !response.data.isError && response.data.data) {
      const r = response.data.data as FeatureConfigData;
      this.updateCurrentConfig(r);
      return true;
    }
    throw new Error(`Error getting feature's configuration: ${response.status}`);
  }

  private updateCurrentConfig(value: FeatureConfigData): void {
    FeatureConfigService.featureConfig.updateFrom(value);
  }
}
